import { GridCellKind } from "@glideapps/glide-data-grid";
import _ from "lodash";
import { formatDatetime } from "../internal/functions.js";
import { CHECKBOX_CELL } from "./custom-renderers/cells/checkboxCell.js";
import "./custom-renderers/cells/linkCell.js";
import "./custom-renderers/cells/loadingCell.js";
import "./custom-renderers/cells/progressCell.js";
import "./custom-renderers/cells/sparklineCell.js";
import "./custom-renderers/cells/stateCell.js";
import "./custom-renderers/cells/tagsCell.js";
import { TEXT_CELL } from "./custom-renderers/cells/textCell.js";
import "./custom-renderers/cells/userAvatarCell.js";
const DEFAULT_COLUMN_WIDTH = 140;
const MIN_COLUMN_WIDTH = 40;
const MULTISELECT = "selected";
function defaultTextColumn(columnId, columnTitle, columnWidth, dataPath) {
  return {
    id: columnId,
    renderer: (record) => {
      const data = dataPath !== void 0 ? _.get(record, dataPath) : void 0;
      return {
        allowOverlay: false,
        copyData: String(data ?? ""),
        data: { kind: TEXT_CELL },
        kind: GridCellKind.Custom
      };
    },
    title: columnTitle,
    tooltip: () => void 0,
    width: columnWidth ?? DEFAULT_COLUMN_WIDTH
  };
}
const getHeatmapPercentage = (min, max, value) => {
  if (min >= max || value >= max)
    return 1;
  if (value <= min)
    return 0;
  return (value - min) / (max - min);
};
const getHeatmapColor = (min, max, value) => {
  const p = getHeatmapPercentage(min, max, value);
  const red = [44, 222];
  const green = [119, 66];
  const blue = [176, 91];
  return `rgb(${red[0] + (red[1] - red[0]) * p}, ${green[0] + (green[1] - green[0]) * p}, ${blue[0] + (blue[1] - blue[0]) * p})`;
};
function defaultNumberColumn(columnId, columnTitle, columnWidth, dataPath, heatmapProps) {
  return {
    id: columnId,
    renderer: (record) => {
      const data = dataPath !== void 0 ? _.get(record, dataPath) : void 0;
      let theme = {};
      if (heatmapProps && data !== void 0) {
        const { min, max } = heatmapProps;
        theme = {
          accentLight: getHeatmapColor(min, max, data),
          bgCell: getHeatmapColor(min, max, data),
          textDark: "white"
        };
      }
      return {
        allowOverlay: false,
        copyData: String(data ?? ""),
        data: { kind: TEXT_CELL },
        kind: GridCellKind.Custom,
        themeOverride: theme
      };
    },
    title: columnTitle,
    tooltip: () => void 0,
    width: columnWidth ?? DEFAULT_COLUMN_WIDTH
  };
}
function defaultSelectionColumn(rowSelection, selectAll) {
  return {
    icon: selectAll ? "allSelected" : rowSelection.length ? "someSelected" : "noneSelected",
    id: MULTISELECT,
    renderer: (_2, idx) => ({
      allowOverlay: false,
      contentAlign: "left",
      copyData: String(rowSelection.hasIndex(idx)),
      data: {
        checked: rowSelection.hasIndex(idx),
        kind: CHECKBOX_CELL
      },
      kind: GridCellKind.Custom
    }),
    themeOverride: { cellHorizontalPadding: 10 },
    title: "",
    tooltip: () => void 0,
    width: 40
  };
}
function defaultDateColumn(columnId, columnTitle, columnWidth, dataPath) {
  return {
    id: columnId,
    renderer: (record) => {
      const data = dataPath !== void 0 ? _.get(record, dataPath) : void 0;
      return {
        allowOverlay: false,
        copyData: data ? formatDatetime(String(data), { outputUTC: false }) : "",
        data: { kind: TEXT_CELL },
        kind: GridCellKind.Custom
      };
    },
    title: columnTitle,
    tooltip: () => void 0,
    width: columnWidth ?? DEFAULT_COLUMN_WIDTH
  };
}
export {
  DEFAULT_COLUMN_WIDTH,
  MIN_COLUMN_WIDTH,
  MULTISELECT,
  defaultDateColumn,
  defaultNumberColumn,
  defaultSelectionColumn,
  defaultTextColumn,
  getHeatmapColor
};
